import React from 'react';
import { useNavigate } from 'react-router';
import plus from "../../assets/images/plus-item.png";
import "./addBtn.css"

export default function AddBtn() {
  const navigate=useNavigate()
  return (
      <div className='add_btn'>
          <div className='add_btn_content'>
              <img onClick={()=>navigate('trip/create-trip')} src={plus} style={{ width:"20px", height:"20px"} } alt="add" /> 
          </div>
    </div>
  )
}
